import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './LandingPageForCompanies.css';
import {
    SectionHero,
    SectionMainBenefits,
    SectionOurMission,
    SectionFactsAndNumbers,
    SectionPackages,
    SectionServices,
    SectionContactUs,
} from '../LandingPage/sectionsForCompanies';
import { withRouter } from 'react-router-dom';
import { getLpSchemaObj, facebookImages, twitterImages } from '../LandingPage/common/helpers';

export const LandingPageForCompanies = ({ history, scrollingDisabled }) => {
    const schemaTitle = 'Werbemöglichkeiten für Unternehmen  | HorseDeal';
    const schemaDescription =
        'Massgeschneiderte Werbemöglichkeiten für dein Unternehmen im Pferdesport. Mehr erfahren.';

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            schema={getLpSchemaObj(schemaTitle, schemaDescription)}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <main className={css.container}>
                        <SectionHero />
                        <SectionMainBenefits />
                        <SectionOurMission history={history} />
                        <SectionFactsAndNumbers />
                        <SectionPackages />
                        <SectionServices />
                        <SectionContactUs />
                    </main>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};

const { bool } = PropTypes;

LandingPageForCompanies.propTypes = {
    scrollingDisabled: bool.isRequired,
};

const mapStateToProps = ({ UI }) => ({
    scrollingDisabled: isScrollingDisabled({ UI }),
});

export default compose(withRouter, connect(mapStateToProps))(LandingPageForCompanies);
